"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.ThingTypeList = void 0;

require("antd/lib/table/style");

var _table = _interopRequireDefault(require("antd/lib/table"));

require("antd/lib/button/style");

var _button = _interopRequireDefault(require("antd/lib/button"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _ThingTypeRow = require("./ThingTypeRow");

var _class, _class2, _temp;

var ThingTypeList = (0, _mobxReact.observer)(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(ThingTypeList, _Component);

  function ThingTypeList(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = ThingTypeList.prototype;

  _proto.render = function render() {
    var thingTypes = this.props.thingTypes;
    return _react.default.createElement("div", null, _react.default.createElement("h2", {
      id: "packing-items"
    }, "Packing Items"), _react.default.createElement(_table.default, {
      rowKey: "id",
      columns: ThingTypeList.Columns,
      dataSource: thingTypes,
      rowSelection: ThingTypeList.RowSelection,
      pagination: false,
      footer: function footer() {
        return _react.default.createElement("div", null, _react.default.createElement(_button.default, null, "Add to Packing List"), " (Feature in Progress)");
      }
    }));
  };

  return ThingTypeList;
}(_react.Component), (0, _defineProperty2.default)(_class2, "Columns", [{
  title: "Item Type",
  dataIndex: "name",
  render: function render(thingTypeName, record) {
    return (0, _ThingTypeRow.createThingType)(record);
  }
}]), (0, _defineProperty2.default)(_class2, "RowSelection", {
  onChange: function onChange(selectedRowKeys, selectedRows) {} // getCheckboxProps: record => ({
  // }),

}), _temp)) || _class;

exports.ThingTypeList = ThingTypeList;